import { UserCheck } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/** Which warm audience an ad set targets, for ad sets published with one. Nothing for other ad sets. */
const WarmAudienceNote = ({ note }) => {
    if (!note) return null

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span role="img" aria-label={note} className="tw:shrink-0" data-testid="warm-audience-note">
                    <UserCheck size={16} className="tw:text-gray-200" />
                </span>
            </TooltipTrigger>
            <TooltipContent className="tw:max-w-80">
                <span>{note}</span>
            </TooltipContent>
        </Tooltip>
    )
}

export default WarmAudienceNote
